import React from "react";
import dateFormat from "dateformat";

import { MdOutlineLocalActivity } from "react-icons/md";
import { Card } from "../blocks";
import { TbFlame } from "react-icons/tb";

const Sorteo = ({ datasorteo }) => {
  const salaInfo = JSON.parse(localStorage.getItem("salaInfo"));

  function mostrarTitulo(idSala) {
    switch (idSala) {
      case 63:
        return "BIG WIN";
      case 65:
        return "HOT WIN";
      case 80:
        return "HAPPY HOURS";
      case 81:
        return "HAPPY HOURS";
      default:
        return "SORTEO HOT SEAT";
    }
  }

  return (
    <Card>
      <div className="flex flex-col w-full">
        {datasorteo.map((item, i) => (
          <div
            key={i}
            className="flex flex-row items-center w-full gap-2 py-4 border-b last:border-b-0"
          >
            <div className="flex flex-col items-start flex-1 gap-1">
              <div className="flex flex-col items-center">
                {item.kind === "HOT_SEAT" ? (
                  <TbFlame size={24} />
                ) : (
                  <MdOutlineLocalActivity size={24} />
                )}
                <span className="text-sm font-semibold">
                  {item.kind === "HOT_SEAT" ? mostrarTitulo(salaInfo.salaId) : item.couponTypeName}
                </span>
              </div>
            </div>
            <div className="flex flex-col items-end">
              <span className="text-xl font-bold text-left">{"S/ " + item.amount}</span>
              <span className="text-xs font-medium text-left">
                Hora: {dateFormat(item.fechaHora, "hh:MM TT")}
              </span>
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
};

export default Sorteo;
